module.exports = __webpack_public_path__ + "img/general_icon.a32e052d.svg";